import { render, staticRenderFns } from "./Enquiries.vue?vue&type=template&id=6f9e6016&scoped=true&"
import script from "./Enquiries.vue?vue&type=script&lang=js&"
export * from "./Enquiries.vue?vue&type=script&lang=js&"
import style0 from "./Enquiries.vue?vue&type=style&index=0&id=6f9e6016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9e6016",
  null
  
)

export default component.exports